import React, { useEffect, useState, } from 'react'
import { Link, useHistory, useParams, } from 'react-router-dom'
import HtmlParser from 'react-html-parser';
import moment from 'moment';
import Swal from 'sweetalert2';
import $ from 'jquery';
import axios from 'axios';
import useAuth from '../../controllers/users/useAuth';

import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, numberSet, separatorsNumbersSet, styles, sendMessageCloseCurrentWindowAsync,
    dateTimeFormatGlobalSet, awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings'
import Menu from '../main/Menu'
import CollectionCashMovementDetails from './CollectionCashMovementDetails';
import { collectionCashMovementModelGet } from '../../models/collections/collectionCashMovement';
import CollectionCashMovementAddEditDetails from './CollectionCashMovementAddEditDetails';
import BuildingHeader from '../buildings/BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { collectionCashModelGet } from '../../models/collections/collectionCash';
import { buildingModelGet } from '../../models/buildings/building';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { purchaseModelGet } from '../../models/expenses/purchase';

const currentMethod = 'CollectionCashMovements';

const { app, colors, collections: dbColle, icons, messages, labels, } = globalSettings;
const { backend, } = globalSettings?.app;
const { html, tempusDominus, } = globalSettings?.react;
const { dataTables, } = globalSettings?.html;
const neutralValue = 0.00;

export default function CollectionCashMovements({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let headerObj = {};
    let dataObj = {};
    const { id, } = useParams();
    const history = useHistory();
    const auth = useAuth();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const dtMovementsId = 'dtMovements';
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ building: true, collectionCash: true, movements: true, });
    const [btnDisabled, setBtnDisabled] = useState(true);
    const [btnAddIsDisbled, setBtnAddIsDisabled] = useState(true);
    const descriptionPercentageObj = {
        success: 'description-percentage text-success',
        primary: 'description-percentage text-primary',
        danger: 'description-percentage text-danger',
    };
    const [findObj, setFindObj] = useState({ e: {}, id: '', description: '', rowIndex: 0, processType: 0, subMethod: '', });
    //#endregion variables

    //#region Collecntion cash
    const movementModelGet = {
        movements: [],
        previousBalance: neutralValue,
        income: neutralValue,
        expense: neutralValue,
        movementAmount: neutralValue,
        dateFrom: new Date(),
        dateTo: new Date(),
        collectionCash: collectionCashModelGet({}),
        building: buildingModelGet({}),
    };
    const [collectionCash, setCollectionCash] = useState(collectionCashModelGet({}));
    const [movementData] = useState(movementModelGet);
    const movementsFromId = 'movementsFrom';
    const movementsToId = 'movementsTo';
    const [movementFromError, setMovementFromError] = useState('');
    const [movementToError, setMovementToError] = useState('');

    const [previousBalance, setPreviusBalance] = useState(neutralValue);
    const [incomeAmount, setIncomeAmount] = useState(neutralValue);
    const [expensesAmount, setExpensesAmount] = useState(neutralValue);
    const [movementAmount, setMovementAmount] = useState(neutralValue);
    //#endregion Collecntion cash

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region movements
    const [showModal, setShowModal] = useState(false);
    const [movement, setMovement] = useState(collectionCashMovementModelGet({}));
    const [movements, setMovements] = useState({
        ...collectionCashMovementModelGet({}),
        movements: [],
        previousBalance: neutralValue,
        income: neutralValue,
        expense: neutralValue,
        movementAmount: neutralValue,
        collectionCash: collectionCashModelGet({}),
        building: buildingModelGet({}),
    });
    const [movementShowModal, setMovementShowModal] = useState(false);
    //#endregion movements

    //#region others
    const controls = {
        buttons: {
            add: {
                id: 'btnAdd',
                className: 'btn btn-outline-success',
            },
            search: {
                id: 'btnSearch',
                className: 'btn btn-outline-info mx-1',
            },
            print: {
                id: 'btnPrint',
                className: 'btn btn-outline-secondary',
            },
            back: {
                id: 'btnBack',
                className: 'btn btn-outline-success mx-1',
            },
        },
        dataTables: {
            movements: {
                buttons: {
                    process: {
                        className: 'btn btn-outline-primary float-right btn-sm',
                        id: 'btnDtMovementsProcess',
                    },
                },
                icons: {
                    process: {
                        id: 'icobtnDtMovementsProcess',
                        className: icons?.fasFa?.cogs,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtMovementsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtMovementsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    process: {
                        id: 'spDtMovementsProcess',
                        className: '',
                    },
                },
            },
        },
        icons: {
            add: {
                id: 'icoAdd',
                className: icons?.plusCircle,
            },
            search: {
                id: 'icoSearch',
                className: icons?.search,
            },
            print: {
                id: 'icoPrint',
                className: icons?.print,
            },
            back: {
                id: 'icoBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            description: {
                id: 'inputDescription',
                className: 'form-control bg-transparent text-black',
            },
            created: {
                id: 'inputCreated',
                className: 'form-control bg-transparent text-black',
            },
            initialBalance: {
                id: 'inputInitialBalance',
                className: 'form-control bg-transparent text-black text-right',
            },
            currentBalance: {
                id: 'inputCurrentBalance',
                className: 'form-control bg-transparent text-black text-right',
            },
            dateFrom: {
                id: 'inputDateFrom',
                className: 'form-control text-black bg-transparent datetimepicker-input',
            },
            dateTo: {
                id: 'inputDateTo',
                className: 'form-control text-black bg-transparent datetimepicker-input',
            },
        },
        radioButtons: {
            all: {
                id: 'rButonAll',
                className: 'icheck-primary d-inline',
                name: 'radioButtonName',
            },
            income: {
                id: 'rButonIncome',
                className: 'icheck-primary d-inline',
                name: 'radioButtonName',
            },
            expense: {
                id: 'rButonExpense',
                className: 'icheck-primary d-inline',
                name: 'radioButtonName',
            },
        },
        spinners: {
            add: {
                id: 'spAdd',
                className: '',
            },
            search: {
                id: 'spSearch',
                className: '',
            },
            print: {
                id: 'spPrint',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
    };
    //#endregion others

    //#region collection cash (methods)
    const collectionCashGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'collectionCashGetAsync';
        let response = responseGet();
        try {
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlCollectionCashes}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    };
    //#endregion collection cash (methods)

    //#region building (methods)
    //#region old code
    // const localBuildingGetAsync = async (buildingId = '') => {
    //     let response = responseGet();
    //     try {
    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };
    //         //result = await axios?.get(`${app?.backend?.urlDev}${app?.backend?.urlApiV1}${app?.backend?.urlBuildings}/${buildingId}`, headerObj);
    //         result = await axios?.get(`${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlBuildings}/${buildingId}`, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             response.msgText = replaceMessages(0, response.msgText).result;
    //             return response;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localBuildingGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code
    //#endregion building (methods)

    //#region movement (methods)
    const movementsCallAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'movementsCallAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.key, subMethod: currentMethod, })?.result && e?.key === 'Enter') {
                $(`#${controls?.buttons?.search?.id}`)?.trigger('click');
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const collectionCashMovementsGetAsync = async ({
        e = {},
        _collectionCash = collectionCashModelGet({}),
        subMethod = ''
    }) => {
        const currentMethod = 'collectionCashMovementsGetAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                if (e?.target?.type !== 'radio') {
                    e?.preventDefault();
                }
            }
            //#endregion initialize

            if (subMethod !== 'dataGetAsync') {
                setShowLoading({ building: false, collectionCash: false, movements: true, });
            }

            //#region old code
            // //#region dataTables set
            // response = await dataTablesSetAsync({
            //     subMethod: currentMethod,
            // });

            // if (!response?.isSuccess || response?.isWarning) {
            //     setBtnDisabled(true);
            //     setShowLoading({ building: false, collectionCash: false, movements: false, });
            //     return;
            // }
            // //#endregion dataTables set
            //#endregion old code

            //#region clear dataTables
            response = await dataTablesClearAsync({
                dtMovements: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion clear dataTables

            //#region previuos data
            _collectionCash = isUndNullEmp({ data: _collectionCash, subMethod: currentMethod, })?.result || isUndNullEmp({ data: _collectionCash?.id, subMethod: currentMethod, })?.result ?
                collectionCash : _collectionCash;
            //#endregion previuos data

            //#region Valida form data
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                response = await validateFormDataAsync({
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setBtnDisabled(true);
                    setShowLoading({ building: false, collectionCash: false, movements: false, });
                    return;
                }
            }
            //#endregion Valida form data

            //#region variables
            let movementsLocal = [movementModelGet];
            let incomeAmountLocal = neutralValue;
            let expenseAmountLocal = neutralValue;
            let movementAmountLocal = neutralValue;
            let previusBalanceLocal = neutralValue;
            //#endregion variables

            //#region total movements set
            response = await totalsMovementsSetAsync({
                previousBalance: neutralValue,
                income: neutralValue,
                expenses: neutralValue,
                movementAmount: neutralValue,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion total movements set

            //#region movement data set
            response = await movementDataSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion movement data set

            //#region data get (movements)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                collectionCashId: movementData?.id,
                buildingId: _collectionCash?.buildingId || '',
                type: movementData?.type,
                dateFrom: movementData?.dateFrom,
                dateTo: movementData?.dateTo,
                method: backend?.methods?.movements,
                languageId: languageObj?.id,
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlCollectionCashes}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            movementsLocal = response?.result?.movements || [];
            previusBalanceLocal = response?.result?.previousBalance || neutralValue;
            incomeAmountLocal = response?.result?.income || neutralValue;
            expenseAmountLocal = response?.result?.expense || neutralValue;
            movementAmountLocal = response?.result?.movementAmount || neutralValue;

            setMovements({});
            setMovements({
                ...movementData,
                movements: movementsLocal,
                previousBalance: previusBalanceLocal,
                income: incomeAmountLocal,
                expense: expenseAmountLocal,
                movementAmount: movementAmountLocal,
                collectionCash: collectionCash,
                building: building,
            });
            //#endregion data get (movements)

            //#region data load in dataTable
            response = await dataTableLoadDataAsync({
                movements: movementsLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion data load in dataTable

            //#region load total movements
            response = await totalsMovementsSetAsync({
                previousBalance: previusBalanceLocal,
                income: incomeAmountLocal,
                expenses: expenseAmountLocal,
                movementAmount: movementAmountLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion load total movements

            //#region collection cash get
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                response = await collectionCashGetAsync({
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setBtnDisabled(true);
                    setShowLoading({ building: false, collectionCash: false, movements: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                setCollectionCash(response?.result || {});
            }
            //#endregion collection cash get

            setBtnDisabled(false);
            setShowLoading({ building: false, collectionCash: false, movements: false, });
        } catch (ex) {
            setBtnDisabled(true);
            setShowLoading({ building: false, collectionCash: false, movements: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const collectionCashMovementEditDetailDeleteAsync = async ({
        // e = {},
        // id = '',
        // description = '',
        // rowIndex = 0,
        // processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'movementEditDetailDeleteAsync';
        let response = responseGet();
        try {
            //#region variables
            const e = findObj?.e;
            const id = findObj?.id;
            const description = findObj?.description;
            //const rowIndex = findObj?.rowIndex;
            const processType = findObj?.processType;

            let collectionCashMovementLocal = {};
            //#endregion variables

            setShowLoading({ building: false, collectionCash: false, movements: true, });

            //#region Initiaize
            //#endregion Initiaize

            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            if (description === dbColle?.apartmentReceiptPayments) {
                switch (processType) {
                    case 2:
                        dataObj = {
                            buildingId: building?.id,
                            apartmentReceiptPaymentId: id,
                            detailsGet: true,
                            limit: 0,
                            ordersBy: [],
                            conditionals: [],
                            url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/`
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );
                        break;
                    default:
                        break;
                }
            } else if (description === dbColle?.purchasePayments) {
                switch (processType) {
                    case 2:
                        dataObj = {
                            conditionals: [],
                            ordersBy: [],
                            purchasePaymentId: id,
                            detailsGet: true,
                            buildingId: building?.id,
                            languageId: languageObj?.id,
                            url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlPurchasePayments}/`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );
                        break;
                    default:
                        break;
                }
            } else if (description === dbColle?.collectionCashMovements) {
                switch (processType) {
                    case -1:
                        collectionCashMovementAddEditDeleteAsync({ e: e, processType: processType, movementId: id, subMethod: currentMethod, });
                        return;
                    case 1:
                        collectionCashMovementAddEditDeleteAsync({ e: e, processType: processType, movementId: id, subMethod: currentMethod, });
                        return;
                    case 2:
                        dataObj = {
                            limit: 0,
                            ordersBy: [],
                            conditionals: [],
                            buildingId: building?.id,
                            collectionCashMovementId: id,
                            detailsGet: true,
                            languageId: languageObj?.id,
                            url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlCollectionCashMovements}/`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj
                        );
                        break;
                    default:
                        break;
                }
            }

            response = result?.data || {};
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#region final set data
            collectionCashMovementLocal = response?.result;
            //#endregion final set data
            //#endregion data get

            //#region set dat
            setMovement(collectionCashMovementLocal);
            //#endregion data set

            setShowModal(true);
            setShowLoading({ building: false, collectionCash: false, movements: false, });
        } catch (ex) {
            setShowLoading({ building: false, collectionCash: false, movements: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const movementDataSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'movementDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.format = '';
            //let dateTimeObj?.dateFrom = {};
            //let dateTimeObj?.dateTo = {};
            //#endregion old code
            const dateTimeObj = {
                formatDate: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo, //ymdTwo: 'y-m-d',
                formatTime: 0,
                dateFrom: $(`#${movementsFromId}`)?.datetimepicker('date')?._d,
                dateTo: $(`#${movementsToId}`)?.datetimepicker('date')?._d,
            }
            //#endregion variables

            //#region methods
            dateTimeObj.dateFrom = $(`#${movementsFromId}`)?.datetimepicker('date')?._d;
            dateTimeObj.dateTo = $(`#${movementsToId}`)?.datetimepicker('date')?._d;

            dateTimeObj.dateFrom = dateTimeFormatGlobalSet({
                date: dateTimeObj?.dateFrom,
                type: dateTimeObj?.formatDate,
                format: dateTimeObj?.formatTime,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            dateTimeObj.dateTo = dateTimeFormatGlobalSet({
                date: dateTimeObj?.dateTo,
                type: dateTimeObj?.formatDate,
                format: dateTimeObj?.formatTime,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            movementData.id = id;
            //movementData.movementsGet = true;
            movementData.dateTo = dateTimeObj?.dateTo;
            movementData.dateFrom = dateTimeObj?.dateFrom;

            response = await radioButtonsStatusCheckedReturnTypeSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            movementData.type = response?.result || '';
            //#endregion old code
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const collectionCashMovementsPrintAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'collectionCashMovementsPrintAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            setShowLoading({ building: false, collectionCash: false, movements: true, });

            //#region collectionCashMovements get
            movements.user = auth.user;
            movements.customId = movements?.customId || '';
            movements.collectionCashId = !isUndNullEmp({ data: movements?.id, subMethod: currentMethod, })?.result ?
                movements?.id :
                !isUndNullEmp({ data: movements?.collectionCashId, subMethod: currentMethod, })?.result ?
                    movements?.collectionCashId :
                    '';
            movements.processType = dbColle?.collectionCashMovements;
            delete movements.id;

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                ...movements,
                buildingId: building?.id,
                building: building,
                languageId: languageObj?.id,
                method: dbColle?.collectionCashMovements,
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlReports}/`
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const collectionCashMovementReport = response?.result || {};
            window?.open(`/${app?.reports?.collectionCashMovementsPrint}/${collectionCashMovementReport?.id}`, '_blank');
            //#endregion add collection cash

            setShowLoading({ building: false, collectionCash: false, movements: false, });
        } catch (ex) {
            setShowLoading({ building: false, collectionCash: false, movements: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const collectionCashMovementAddEditDeleteAsync = async ({
        e = {},
        movementId = '',
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'movementAddEditDeleteAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region variables
            let showModalLocal = false;
            //#endregion variables

            if (processType === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, collectionCash: false, movements: true, });
            }

            //#region collection cash get movement
            setProcessType(processType);

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            switch (processType) {
                case -1:
                    //#region collectionCashMovement get
                    headerObj.url = `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlCollectionCashMovements}/${movementId}`;
                    result = await axios?.get(
                        headerObj?.url,
                        headerObj
                    );

                    response = result?.data || {};
                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, collectionCash: false, movements: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                    //#endregion collectionCashMovement

                    setShowLoading({ building: false, collectionCash: false, movements: false, });

                    //#region variables
                    const collectionCashMovementLocal = response.result;
                    const dataObj = {
                        amount: separatorsNumbersSet({
                            number: collectionCashMovementLocal.amount * (collectionCashMovementLocal.type === 'E' ? -1 : 1),
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        date: dateTimeFormatGlobalSet({
                            date: collectionCashMovementLocal?.date,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                    }
                    //#endregion variables

                    //#region message show
                    let msgTextObj = {
                        one: '',
                        two: '',
                    };
                    msgTextObj.one = `${labels?.type?.[languageObj?.id]}: <b>${collectionCashMovementLocal.type === 'E' ?
                        labels?.egress?.[languageObj?.id] :
                        labels?.income?.[languageObj?.id]}</b><br/>`;
                    msgTextObj.one += `${labels?.date?.[languageObj?.id]}: <b>${dataObj?.date}</b><br/>`;
                    msgTextObj.one += `${labels?.amount?.[languageObj?.id]}: <b>${dataObj?.amount}</b><br/>`;
                    msgTextObj.two = `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

                    let swalProperties = {
                        icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                        title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                        html: `${msgTextObj?.one}${msgTextObj?.two}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                        showCancelButton: true, //!Swal.isLoading(), //true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        preConfirm: async () => {
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal?.update({
                                    icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                                    title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                                    html: `${msgTextObj?.one}`,
                                    showConfirmButton: false,
                                });

                                //#region purchases delete
                                headerObj = {
                                    headers: {
                                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                        languageId: languageObj?.id,
                                    },
                                    url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlCollectionCashMovements}/${movementId}`,
                                };

                                result = await axios?.delete(
                                    headerObj?.url,
                                    headerObj,
                                );

                                response = result?.data;

                                if (!response?.isSuccess || response?.isWarning) {
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    });
                                    return;
                                }
                                //#endregion purchase delete

                                //#region dtPurchases update
                                $(`#${controls?.buttons?.search?.id}`)?.trigger('click');
                                //#endregion dtPurchases update

                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: 0,
                                    msgText: `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                            } catch (ex) {
                                //#region Error
                                response.isSuccess = false;
                                response.msgType = -1;
                                response.msgText = `Method: ${currentMethod}<br/>`;
                                response.msgText += `Error: ${ex?.message}`;
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });
                                //#endregion Error
                            }
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                    };
                    //#endregion message show

                    await Swal.fire(swalProperties);
                    return;
                case 0:
                    setMovement(
                        collectionCashMovementModelGet({
                            buildingId: building?.id,
                            collectionCashId: collectionCash?.id,
                            type: '',
                            userId: auth?.user?.uid,
                        })
                    );
                    showModalLocal = true;
                    break;
                case 1:
                    headerObj.url = `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlCollectionCashMovements}/${movementId}`
                    result = await axios?.get(
                        headerObj?.url,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, collectionCash: false, movements: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    setMovement(response?.result || {});
                    showModalLocal = true;
                    break;
                default:
                    break;
            }
            //#endregion collection cash get movement

            if (showModalLocal) {
                if (processType === 0) {
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                }
            }

            setMovementShowModal(showModalLocal);
            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, collectionCash: false, movements: false, });
            }
        } catch (ex) {
            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, collectionCash: false, movements: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localCollectionCashMovementDeletePostAsync = async (movementId = '') => {
    //     let response = responseGet();
    //     try {
    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.fourthySeconds, false, true, null, '');

    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };

    //         //result = await axios.delete(`${app?.backend?.urlDev}${app?.backend?.urlApiV1}${app?.backend?.urlCollectionCashMovements}/${movementId}`, headerObj);
    //         result = await axios.delete(`${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlCollectionCashMovements}/${movementId}`, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             //sendMessage(response.msgType, replaceMessages(0, response.msgText).result, 0, true, false, null, '');
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return;
    //         }

    //         $(`#${controls?.buttons?.search?.id}`)?.trigger('click');
    //         //sendMessage(-2, '', 0, false, false, null, '');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCollectionCashMovementDeletePostAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code
    //#endregion movement (methods)

    //#region others (methods)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let isEditLocal = false;
            let isDeleteLocal = false;
            let buildingLocal = buildingModelGet({});
            let buildingsLocal = [buildingModelGet({})];
            let collectionCashLocal = collectionCashModelGet({});
            //#endregion variables

            setShowLoading({ building: true, collectionCash: true, movements: true, });

            //#region dataTables set
            response = await dataTablesSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion dataTables set

            //#region set status checked
            response = await radioButtonsStatusCheckedSetAsync({
                all: true,
                income: false,
                expenses: false,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion set status checked

            //#region dateTime in control sets
            response = await dateInControlSetAsync({
                movementFrom: undefined,
                movementTo: undefined,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion dateTime in control sets

            //#region data get
            //#region data get (collection cash)
            response = await collectionCashGetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            collectionCashLocal = response?.result || {};
            setCollectionCash(collectionCashLocal);
            //#endregion data get (collection cash)

            //#region data get (building)
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: app?.backend?.urlCollectionCashes,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            buildingsLocal = response?.result?.buildings || [];

            if (!isUndNullEmp({ data: buildingsLocal, subMethod: currentMethod, })?.result && buildingsLocal?.length > 0) {
                buildingLocal = buildingsLocal?.find(({ id, }) => id === collectionCashLocal?.buildingId) || {};
                if (!isUndNullEmp({ data: buildingLocal?.id, subMethod: currentMethod, })?.result) {
                    setBuilding(buildingLocal);

                    //#region set enabled btn add
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result;

                    isDeleteLocal = isEditLocal;
                    setBtnAddIsDisabled(!(isEditLocal && isDeleteLocal));
                    //#endregion set enabled btn add
                } else {
                    setBtnDisabled(true);
                    setShowLoading({ building: false, collectionCash: false, movements: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            } else {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion data get (building)

            //#region movements get
            response = await collectionCashMovementsGetAsync({
                e: null,
                _collectionCash: collectionCashLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, collectionCash: false, movements: false, });
                return;
            }
            //#endregion movements get
            //#endregion data get

            setShowLoading({ building: false, collectionCash: false, movements: false, });
        } catch (ex) {
            setBtnDisabled(true);
            setShowLoading({ building: false, collectionCash: false, movements: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const validateFormDataAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const dataTimeOb?.from = $(`#${controls?.inputs?.dateFrom?.id}`)?.val();
            //const dataTimeOb?.to = $(`#${controls?.inputs?.dateTo?.id}`)?.val();
            //#endregion old code
            const dataTimeOb = {
                dateFrom: $(`#${controls?.inputs?.dateFrom?.id}`)?.val(),
                dateTo: $(`#${controls?.inputs?.dateTo?.id}`)?.val(),
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: movementData?.dateFrom, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: dataTimeOb?.dateFrom, subMethod: currentMethod, })?.result) {
                setMovementToError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: movementData?.dateTo, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: dataTimeOb?.dateTo, subMethod: currentMethod, })?.result) {
                setMovementToError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateInControlSetAsync = async ({
        movementFrom = undefined,
        movementTo = undefined,
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.dateFrom = '';
            //let dateTimeObj?.dateTo = '';
            //const dateTimeObj?.format = tempusDominus?.format?.date?.DDMMYYYY;
            //const dateTimeObj?.formatTwo = tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.startMonth = moment().startOf('month')._d;
            //const dateTimeObj?.endMonth = moment().endOf('month')._d;
            //#endregion old code
            const dateTimeObj = {
                dateFrom: '',
                dateTo: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
                startMonth: moment()?.startOf('month')._d,
                endMonth: moment()?.endOf('month')._d,
            };
            //#endregion variables

            //#region methods
            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: tempusDominus?.icons,
                buttons: tempusDominus?.buttons,
                tooltips: tempusDominus?.tooltips,
                locale: 'es',
            });

            //#region movementFrom
            if (!isUndNullEmp({ data: movementFrom, subMethod: currentMethod, })?.result) {
                dateTimeObj.dateFrom = dateTimeFormatGlobalSet({
                    date: movementFrom,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.dateFrom = dateTimeFormatGlobalSet({
                    date: dateTimeObj?.startMonth,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $(`#${movementsFromId}`)?.datetimepicker({
                date: moment(dateTimeObj?.dateFrom, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion movement from

            //#region movement to
            if (!isUndNullEmp({ data: movementTo, subMethod: currentMethod, })?.result) {
                dateTimeObj.dateTo = dateTimeFormatGlobalSet({
                    date: movementTo,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.dateTo = dateTimeFormatGlobalSet({
                    date: dateTimeObj?.endMonth,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $(`#${movementsToId}`)?.datetimepicker({
                date: moment(dateTimeObj?.dateTo, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion movement to
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const goToBackAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region methods
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            controlsStatusSet({ processType: 4, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            history.push(backend?.urlCollectionCashes);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            //#endregion methods
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const radioButtonsStatusCheckedSetAsync = async ({
        all = false,
        income = false,
        expenses = false,
        subMethod = '',
    }) => {
        const currentMethod = 'radioButtonsStatusCheckedSetAsync';
        let response = responseGet();
        try {
            $(`#${controls?.radioButtons?.all?.id}`)?.prop({ checked: all, });
            $(`#${controls?.radioButtons?.income?.id}`)?.prop({ checked: income, });
            $(`#${controls?.radioButtons?.expense?.id}`)?.prop({ checked: expenses, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const radioButtonsStatusCheckedReturnTypeSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'radioButtonsStatusCheckedReturnTypeSetAsync';
        let response = responseGet();
        try {
            if ($(`#${controls?.radioButtons?.all?.id}`)?.prop('checked')) {
                response.result = 'a';
            } else if ($(`#${controls?.radioButtons?.income?.id}`)?.prop('checked')) {
                response.result = 'i';
            } else if ($(`#${controls?.radioButtons?.expense?.id}`)?.prop('checked')) {
                response.result = 'e';
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTableMovementsSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableMovementsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtMovementsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: 'orderDate', width: '0%', orderable: false, visible: false, searchable: false, },
                    { title: labels?.date?.[languageObj?.id], width: '10%', orderable: false, },
                    {
                        title: labels?.reference?.[languageObj?.id],
                        orderable: false,
                        render: function (data, type, row) {
                            return `<span style='font-size:13px;'>${data}</span>`;
                        },
                        width: '55%',
                    },
                    {
                        title: labels?.amount?.[languageObj?.id],
                        className: 'text-right',
                        orderable: false,
                        render: function (data, type, row) {
                            //#region variables
                            var colorLocal = 'black';
                            let amountLocal = undefined;
                            //#endregion variables

                            //#region methods
                            if (languageObj?.numbers?.separators?.thousands === '.') {
                                amountLocal = data?.replaceAll('.', '');
                                amountLocal = amountLocal?.replaceAll(',', '.');
                                amountLocal = numberSet({
                                    number: amountLocal,
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result;
                            } else if (languageObj?.numbers?.separators?.thousands === ',') {
                                amountLocal = numberSet({
                                    number: data.replaceAll(',', ''),
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result;
                            }

                            if (amountLocal > 0) {
                                colorLocal = colors?.successColorExp;
                            } else {
                                colorLocal = colors?.dangerColorExp;
                            }
                            //return '<span style="color:' + color + '">' + data + '</span>';
                            return `<span style='color:${colorLocal};'>${data}</span>`;
                            //#endregion methods
                        },
                        width: '15%',
                    },
                    { title: labels?.balance?.[languageObj?.id], className: 'text-right', width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                ordering: true,
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                searching: false,
                //}).buttons().container().appendTo(`#${dtMovementsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            response = await dataTableMovementsSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = await queryCodeSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTableLoadDataAsync = async ({
        movements = [],
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableLoadDataAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            //#endregion variables

            //#region methods
            movements?.forEach((detail) => {
                //#region variables
                dataObj = {
                    // orderDate: dateTimeFormatGlobalSet({
                    //     date: detail?.date,
                    //     type: tempusDominus?.format?.date?.ymdTwo,
                    //     format: 0,
                    //     addTime: false,
                    //     secondsShow: false,
                    //     subMethod: currentMethod,
                    // })?.result,
                    orderDate: detail?.date,
                    date: dateTimeFormatGlobalSet({
                        date: detail?.date,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        subMethod: currentMethod,
                    })?.result,
                    reference: dataDetailGet({
                        processType: 2,
                        movement: detail,
                        subMethod: currentMethod,
                    })?.result,
                    amount: detail?.id === detail?.collectionCashId ?
                        '' :
                        separatorsNumbersSet({
                            number: detail?.amount,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    balance: separatorsNumbersSet({
                        number: detail?.balance,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                };
                //#endregion variables

                //#region methods
                dtRows.push([
                    dataObj?.orderDate,
                    dataObj?.date,
                    dataObj?.reference,
                    dataObj?.amount,
                    dataObj?.balance,
                    detail?.type !== 0 ?
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.collection,
                            showDetails: true,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: (detail?.collection === dbColle?.collectionCashMovements) &&
                                processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.edit?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                })?.result,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: (detail?.collection === dbColle?.collectionCashMovements) &&
                                processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.delete?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                }).result,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result :
                        '',
                ]);
                //#endregion methods
            });

            $(`#${dtMovementsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesClearAsync = async ({
        dtMovements = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesClearAsync';
        let response = responseGet();
        try {
            if (dtMovements) {
                $(`#${dtMovementsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response
    }

    const totalsMovementsSetAsync = async ({
        previousBalance = neutralValue,
        income = neutralValue,
        expenses = neutralValue,
        movementAmount = neutralValue,
        subMethod = '',
    }) => {
        const currentMethod = 'totalsMovementsSetAsync';
        let response = responseGet();
        try {
            setIncomeAmount(income);
            setExpensesAmount(expenses);
            setPreviusBalance(previousBalance);
            setMovementAmount(movementAmount);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region initialize
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion initialize

            //#region movements
            $(`#${dtMovementsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtMovementsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            setFindObj({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            $(`#${controls?.dataTables?.movements?.buttons?.process?.id}`)?.trigger('click');
                            break;
                        case 'details':
                            setFindObj({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            $(`#${controls?.dataTables?.movements?.buttons?.process?.id}`)?.trigger('click');
                            break;
                        case 'delete':
                            setFindObj({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            $(`#${controls?.dataTables?.movements?.buttons?.process?.id}`)?.trigger('click');
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion movements
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.add?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.search?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.search?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.print?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.print?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.selects?.suppliers?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.dateFrom?.id}`).attr({ readOnly: (processType !== 0) });
            $(`#${controls?.inputs?.dateTo?.id}`).attr({ readOnly: (processType !== 0) });
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.movements?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.movements?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.add?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.search?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.print?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    const dataDetailGet = ({
        processType = 0,
        movement = {
            id: '',
            date: new Date(),
            type: 0,
            collection: '',
            apartment: apartmentModelGet({}),
            apartmentReceipt: apartmentReceiptModelGet({}),
            dateTwo: new Date(),
            purchase: purchaseModelGet({}),
            reference: '',
            created: new Date(),
            amount: neutralValue,
            balance: neutralValue,
        },
        subMethod = '',
    }) => {
        const currentMethod = 'dataDetailGet';
        let response = responseGet();
        try {
            switch (processType) {
                case 0:
                    response.result = movement?.id;
                    break;
                case 1:
                    response.result = dateTimeFormatGlobalSet({
                        date: movement?.date,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                case 2:
                    if (movement?.type !== 0) {
                        response.result = `${labels?.type?.[languageObj?.id]}: ${movement?.type === 1 ? labels?.income?.[languageObj?.id] : labels?.egress?.[languageObj?.id]}; `;
                        switch (movement?.collection) {
                            case dbColle?.apartmentReceiptPayments:
                                if (!isUndNullEmp({ data: movement?.apartment?.identifier, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.apartment?.[languageObj?.id]}: ${movement?.apartment?.identifier}; `;
                                }
                                if (!isUndNullEmp({ data: movement?.apartmentReceipt?.receiptNumberApartment, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.receipt?.[languageObj?.id]}: ${movement?.apartmentReceipt?.receiptNumberApartment}; `;
                                }
                                response.result += `${labels?.date?.[languageObj?.id]}: ${dateTimeFormatGlobalSet({
                                    date: movement?.dateTwo,
                                    type: languageObj?.format?.f1,
                                    format: 0,
                                    addTime: false,
                                    secondsShow: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result}; `;
                                break;
                            case dbColle?.purchasePayments:
                                if (!isUndNullEmp({ data: movement?.purchase?.number, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.purchase?.[languageObj?.id]}: ${movement?.purchase?.number}; `;
                                    response.result += `${labels?.number?.[languageObj?.id]}: ${movement?.purchase?.invoiceNumber}; `;
                                    response.result += `${labels?.date?.[languageObj?.id]}: ${dateTimeFormatGlobalSet({
                                        date: movement?.purchase?.date,
                                        type: languageObj?.format?.date?.f1,
                                        format: 0,
                                        addTime: false,
                                        secondsShow: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result}; `;
                                }
                                break;
                            case dbColle?.collectionCashMovements:
                                //response.result += `${replaceMessages(0, movement?.reference).result}; `;
                                response.result += `${movement?.reference}; `;
                                response.result += `${labels?.date?.[languageObj?.id]}: ${dateTimeFormatGlobalSet({
                                    date: movement?.created,
                                    type: languageObj?.format?.date?.f1,
                                    format: 0,
                                    addTime: false,
                                    secondsShow: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result}; `;
                                break;
                            default:
                                break;
                        }

                        if (movement?.collection === dbColle?.collectionCashMovements) {
                            //response.result += `${labels?.reference?.[languageObj?.id]}: ${replaceMessages(0, movement?.remark).result}`;
                            response.result += `${labels?.reference?.[languageObj?.id]}: ${movement?.remark}`;
                        } else {
                            //response.result += `${labels?.reference?.[languageObj?.id]}: ${replaceMessages(0, movement?.reference).result}`;
                            response.result += `${labels?.reference?.[languageObj?.id]}: ${movement?.reference}`;
                        }
                    } else {
                        if (movement?.id !== movement?.collectionCashId) {
                            //response.result = `${labels?.reference?.[languageObj?.id]}: ${replaceMessages(0, movement?.reference).result}`;
                            response.result = `${labels?.reference?.[languageObj?.id]}: ${movement?.reference}`;
                        } else {
                            //response.result = `${replaceMessages(0, movement?.reference).result}`;
                            response.result = `${movement?.reference}`;
                        }
                    }
                    break;
                case 3:
                    response.result = movement?.id !== movement?.collectionCashId ?
                        separatorsNumbersSet({
                            number: movement?.amount,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result :
                        '';
                    break;
                case 4:
                    response.result = separatorsNumbersSet({
                        number: movement?.balance,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [id]); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others (methods)

    return (
        <div>
            <Menu viewName='collection' process='collectionCashes' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.movements?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={backend?.urlCollectionCashes}>{labels?.cashRegisters?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.movements?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>
                                {/*buildings*/}
                                <BuildingHeader buildingsId={''}
                                    building={building}
                                    buildings={[]}
                                    btnSyncDisabled={''}
                                    methodGetAsync={null}
                                    processType={1}
                                    headerSectionValues={{}}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*collectionCash*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.collectionCash}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.cashRegister?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.collectionCashLogo}></img> - {labels?.cashRegister?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.add?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.description?.id}
                                                            className={controls?.inputs?.description?.className}
                                                            placeholder={labels?.cashRegister?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.cashRegister?.[languageObj?.id]}
                                                            value={collectionCash?.description || ''} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.collectionCash} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.created?.id}
                                                            className={controls?.inputs?.created?.className}
                                                            placeholder={labels?.created?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.created?.[languageObj?.id]}
                                                            value={
                                                                dateTimeFormatGlobalSet({
                                                                    date: collectionCash?.date,
                                                                    type: languageObj?.format?.f1,
                                                                    format: 0,
                                                                    addTime: false,
                                                                    secondsShow: false,
                                                                    languageId: languageObj?.id,
                                                                    subMethod: 'input - collectionCashDate',
                                                                })?.result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.calendarAlt} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.initialBalance?.id}
                                                            className={controls?.inputs?.initialBalance?.className}
                                                            placeholder={labels?.initialBalance?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.initialBalance?.[languageObj?.id]}
                                                            value={
                                                                separatorsNumbersSet({
                                                                    number: numberSet({
                                                                        number: (collectionCash?.initialBalance + collectionCash?.initialBalanceCash),
                                                                        type: 'd',
                                                                        languageId: languageObj?.id,
                                                                        subMethod: 'input - collectionCashInitialBalance',
                                                                    })?.result,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'input - collectionCashInitialBalance',
                                                                }).result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.moneyBillWave} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.currentBalance?.id}
                                                            className={controls?.inputs?.currentBalance?.className}
                                                            placeholder={labels?.currentBalance?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.currentBalance?.[languageObj?.id]}
                                                            value={
                                                                separatorsNumbersSet({
                                                                    number: numberSet({
                                                                        number: collectionCash?.currentBalance,
                                                                        type: 'd',
                                                                        languageId: languageObj?.id,
                                                                        subMethod: 'input - collectionCashCurrentBalance',
                                                                    })?.result,
                                                                    withDecimals: true,
                                                                    consoleLogErrorShow: true,
                                                                    subMethod: 'input - collectionCashCurrentBalance',
                                                                }).result
                                                            } />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.moneyBillWave} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'>
                                    </div> */}
                                </div>{/*card*/}

                                {/*movements*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.movements}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.movements?.[languageObj?.id]}
                                                style={styles?.cardHeaderLogo}
                                                src={globalSettings?.images?.movementsLogo}>
                                            </img> - {labels?.movements?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.add?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-3'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <div id={movementsFromId}
                                                            className='input-group date'
                                                            data-target-input='nearest'>
                                                            <input id={controls?.inputs?.dateFrom?.id}
                                                                className={controls?.inputs?.dateFrom?.className}
                                                                data-target={`#${movementsFromId}`}
                                                                data-toggle='datetimepicker'
                                                                disabled={btnDisabled}
                                                                onFocus={() => setMovementFromError('')}
                                                                onKeyDown={(e) => movementsCallAsync({ e: e, subMethod: 'btn - movementFrom', })}
                                                                placeholder={labels?.from?.[languageObj?.id]}
                                                                tooltip='tooltip'
                                                                title={labels?.from?.[languageObj?.id]}
                                                                type='text' />

                                                            <div className='input-group-append' data-target={`#${movementsFromId}`} data-toggle='datetimepicker'>
                                                                <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementFromError)}</div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <div id={movementsToId}
                                                            className='input-group date'
                                                            data-target-input='nearest'>
                                                            <input id={controls?.inputs?.dateTo?.id}
                                                                className={controls?.inputs?.dateTo?.className}
                                                                data-target={`#${movementsToId}`}
                                                                data-toggle='datetimepicker'
                                                                disabled={btnDisabled}
                                                                onFocus={() => setMovementToError('')}
                                                                onKeyDown={(e) => movementsCallAsync({ e: e, subMethod: 'btn - movementTo', })}
                                                                placeholder={labels?.to?.[languageObj?.id]}
                                                                tooltip='tooltip'
                                                                title={labels?.to?.[languageObj?.id]}
                                                                type='text' />

                                                            <div className='input-group-append' data-target={`#${movementsToId}`} data-toggle='datetimepicker'>
                                                                <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementToError)}</div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='row text-center text-muted'>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className={controls?.radioButtons?.all?.className}>
                                                                <input disabled={btnDisabled}
                                                                    type='radio'
                                                                    id={controls?.radioButtons?.all?.id}
                                                                    name={controls?.radioButtons?.all?.name}
                                                                    onClick={(e) => collectionCashMovementsGetAsync({
                                                                        e: e,
                                                                        _collectionCash: collectionCash,
                                                                        subMethod: 'rButonAll - collectionCashMovementSearch',
                                                                    })} />
                                                                <label htmlFor={controls?.radioButtons?.all?.id}>
                                                                    {labels?.all?.[languageObj?.id]}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className={controls?.radioButtons?.income?.className}>
                                                                <input disabled={btnDisabled}
                                                                    type='radio'
                                                                    id={controls?.radioButtons?.income?.id}
                                                                    name={controls?.radioButtons?.income?.name}
                                                                    onClick={(e) => collectionCashMovementsGetAsync({
                                                                        e: e,
                                                                        _collectionCash: collectionCash,
                                                                        subMethod: 'rButonIncome - collectionCashMovementSearch',
                                                                    })} />
                                                                <label htmlFor={controls?.radioButtons?.income?.id}>
                                                                    {labels?.income?.[languageObj?.id]}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className={controls?.radioButtons?.expense?.className}>
                                                                <input disabled={btnDisabled}
                                                                    type='radio'
                                                                    id={controls?.radioButtons?.expense?.id}
                                                                    name={controls?.radioButtons?.expense?.name}
                                                                    onClick={(e) => collectionCashMovementsGetAsync({
                                                                        e: e,
                                                                        _collectionCash: collectionCash,
                                                                        subMethod: 'rButonExpense - collectionCashMovementSearch',
                                                                    })} />
                                                                <label htmlFor={controls?.radioButtons?.expense?.id}>
                                                                    {labels?.egress?.[languageObj?.id]}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group text-right'>
                                                    <button id={controls?.buttons?.add?.id}
                                                        className={controls?.buttons?.add?.className}
                                                        disabled={btnDisabled || btnAddIsDisbled}
                                                        onClick={(e) => collectionCashMovementAddEditDeleteAsync({ e: e, processType: 0, movementId: '', subMethod: 'btn - collectionCashMovementAdd', })}
                                                        tooltip='tooltip'
                                                        title={labels?.add?.[languageObj?.id]}>
                                                        <i id={controls?.icons?.add?.id} className={controls?.icons?.add?.className} /> <span id={controls?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.search?.id}
                                                        className={controls?.buttons?.search?.className}
                                                        disabled={btnDisabled}
                                                        onClick={(e) => collectionCashMovementsGetAsync({ e: e, _collectionCash: collectionCash, subMethod: 'btn - collectionCashMovementSearch', })}
                                                        tooltip='tooltip'
                                                        title={labels?.search?.[languageObj?.id]}>
                                                        <i id={controls?.icons?.search?.id} className={controls?.icons?.search?.className} /> <span id={controls?.spinners?.search?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.print?.id}
                                                        className={controls?.buttons?.print?.className}
                                                        disabled={btnDisabled}
                                                        onClick={(e) => collectionCashMovementsPrintAsync({e: e, subMethod: 'btn - collectionCashMovementPrint'})}
                                                        tooltip='tooltip'
                                                        title={labels?.toPrint?.[languageObj?.id]} >
                                                        <i id={controls?.icons?.print?.id} className={controls?.icons?.print?.className} /> <span id={controls?.spinners?.print?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.className}
                                                        onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - goToBack', })}
                                                        tooltip='tooltip'
                                                        title={labels?.back?.[languageObj?.id]}>
                                                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div>
                                                    <button id={controls?.dataTables?.movements?.buttons?.process?.id}
                                                        className={controls?.dataTables?.movements?.buttons?.process?.className}
                                                        disabled={isUndNullEmp({ data: building?.id, subMethod: currentMethod, })?.result}
                                                        hidden={true}
                                                        tooltip='tooltip'
                                                        title={labels?.process?.[languageObj?.id]}
                                                        onClick={(e) => collectionCashMovementEditDetailDeleteAsync({ subMethod: 'btn - collectionCashMovenentDetailFind', })}>
                                                        <i id={controls?.dataTables?.movements?.icons?.process?.id} className={controls?.dataTables?.movements?.icons?.process?.className} /> <span id={controls?.dataTables?.movements?.spinners?.process?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <div className={dataTables?.formats?.tableResponsiveSm}>
                                                        <table id={dtMovementsId} className={dataTables?.formats?.smStripedBordered}></table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-footer'>
                                        <div className='row'>
                                            <div className='col-sm-3 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className={descriptionPercentageObj?.primary}><i className={icons?.caretLeft}></i> {
                                                        separatorsNumbersSet({
                                                            number: previousBalance,
                                                            withDecimals: true,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'lbl - collectionCashPreviousBalance',
                                                        })?.result
                                                    }</span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{labels?.previousBalance?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                            <div className='col-sm-3 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className={descriptionPercentageObj?.success}><i className={icons?.caretUp}></i> {
                                                        separatorsNumbersSet({
                                                            number: incomeAmount,
                                                            withDecimals: true,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'lbl - collectionCashIncomeAmount',
                                                        })?.result
                                                    }</span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{labels?.incomes?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                            <div className='col-sm-3 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className={descriptionPercentageObj?.danger}><i className={icons?.caretDown}></i> {
                                                        separatorsNumbersSet({
                                                            number: expensesAmount,
                                                            withDecimals: true,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'lbl - collectionCashExpensesAmount',
                                                        })?.result
                                                    }</span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{labels?.egresses?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                            <div className='col-sm-3 col-6'>
                                                <div className='description-block'>
                                                    <span className={movementAmount < 0 ?
                                                        descriptionPercentageObj?.danger :
                                                        (movementAmount > 0 ?
                                                            descriptionPercentageObj?.success :
                                                            descriptionPercentageObj?.primary)}>
                                                        <i className={movementAmount < 0 ? icons?.caretDown : (movementAmount > 0 ? icons?.caretUp : icons?.caretRight)}></i> {
                                                            //separatorsNumbersSet(movementAmount).result
                                                            separatorsNumbersSet({
                                                                number: movementAmount,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'lbl - collectionCashMovementAmount',
                                                            })?.result
                                                        }
                                                    </span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{labels?.movements?.[languageObj?.id]}</span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>{/* /.content */}

            </div>

            {showModal ?
                <CollectionCashMovementDetails $={$}
                    auth={auth}
                    collectionCashMovement={movement}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    languageObj={languageObj} />
                :
                <></>
            }

            {movementShowModal ?
                <CollectionCashMovementAddEditDetails $={$}
                    auth={auth}
                    movement={movement}
                    setMovement={setMovement}
                    processType={processType}
                    btnMovementSearchId={controls?.buttons?.search?.id}
                    showModal={movementShowModal}
                    setShowModal={setMovementShowModal}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}